<template>
    <div class="position-box">
        <div class="head">
            <img class="back" v-if="theme" src="@/assets/theme/icon_back.png" @click="back" alt="">
            <img class="back" v-else src="@/assets/icon_back.png" @click="back" alt="">
            <div class="title">{{$t('safe.center')}}</div>
        </div>
        <div class="cotainer">
            <ul class="ul-box" v-if="lang == 'ar'">
                <li class="li" @click="link(1)">
                  <template v-if="!isMail">
                    <img class="arrow" v-if="theme" src="@/assets/theme/icon_back.png" alt="">
                    <img class="arrow" v-else src="@/assets/alb/icon_back.png" alt="">
                    <div class="mail no-mail" style="padding: 0 0 0 .2rem;text-align: left">{{$t('bind.wrz')}}</div>
                  </template>
                  <div class="mail" v-else>{{$t('bind.yrz')}}</div>
                  <div class="text">{{$t('bind.title')}}</div>
                </li>
                <router-link class="li" tag="li" to="/modifyPwd">
                  <img class="arrow" v-if="theme" src="@/assets/theme/icon_back.png" alt="">
                  <img class="arrow" v-else src="@/assets/alb/icon_back.png" alt="">
                  <div class="text">{{$t('safe.lgpwd')}}</div>
                </router-link>
                <router-link class="li" tag="li" to="/setWithdrawPwd">
                  <img class="arrow" v-if="theme" src="@/assets/theme/icon_back.png" alt="">
                  <img class="arrow" v-else src="@/assets/alb/icon_back.png" alt="">
                  <div class="text">{{$t('tips.jymm')}}</div>
                </router-link>
                <li class="li" @click="link(2)">
                  <template v-if="!sec_question">
                    <img class="arrow" v-if="theme" src="@/assets/theme/icon_back.png" alt="">
                    <img class="arrow" v-else src="@/assets/alb/icon_back.png" alt="">
                  </template>
                  <div class="text">{{$t('mbwt.title')}}</div>
                  <div class="status" v-if="sec_question">{{$t('mbwt.ysz')}}</div>
                </li>
            </ul>
            <ul class="ul-box" v-else>
                <li class="li" @click="link(1)">
                    <div class="text">{{$t('bind.title')}}</div>
                    <div class="mail" v-if="isMail">{{$t('bind.yrz')}}</div>
                    <template v-else>
                      <div class="mail no-mail">{{$t('bind.wrz')}}</div>
                      <img class="arrow" v-if="theme" src="@/assets/theme/jiantou_white.png" alt="">
                      <img class="arrow" v-else src="@/assets/user/jiantou.png" alt="">
                    </template>
                </li>
                <router-link class="li" tag="li" to="/modifyPwd">
                    <div class="text">{{$t('safe.lgpwd')}}</div>
                    <img class="arrow" v-if="theme" src="@/assets/theme/jiantou_white.png" alt="">
                    <img class="arrow" v-else src="@/assets/user/jiantou.png" alt="">
                </router-link>
                <router-link class="li" tag="li" to="/setWithdrawPwd">
                    <div class="text">{{$t('tips.jymm')}}</div>
                    <img class="arrow" v-if="theme" src="@/assets/theme/jiantou_white.png" alt="">
                    <img class="arrow" v-else src="@/assets/user/jiantou.png" alt="">
                </router-link>
                <li class="li" @click="link(2)">
                    <div class="text">{{$t('mbwt.title')}}</div>
                    <div class="status" v-if="sec_question">{{$t('mbwt.ysz')}}</div>
                    <template v-else>
                      <img class="arrow" v-if="theme" src="@/assets/theme/jiantou_white.png" alt="">
                      <img class="arrow" v-else src="@/assets/user/jiantou.png" alt="">
                    </template>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
export default {
    name: 'securityCenter',
    data () {
        return {
            theme: false,
            sec_question: false,
            securityText: '',
            emailText: '',
            isMail: '',
            lang: 'en'
        }
    },
    created(){
      this.theme = JSON.parse(localStorage.getItem('theme'));
      this.lang = localStorage.getItem('language') || 'en';
    },
    mounted() {
        this.getCenterLevel();
        this.getsSecQty()
    },
    methods: {
       back(){
           this.$router.push('/set')
       },
       getCenterLevel(){
            let that = this;
            let params = {
                level: 1
            }
            this.$ajax.get('/web/getCenterLevel',{params}).then((res) => {
                let resData = res.data.data;
                that.isMail = resData.email;
            }).catch(function(err){
                console.log(err)
            })
        },
        getsSecQty(){
            var that = this;
            this.$ajax.get('/web/info',{}).then((res) => {
                let resData = res.data.data;
                that.sec_question = resData.sec_question ? true : false;
            }).catch(function(err){
                console.log(err)
            })
        },
        link(obj){
            if(obj == 1){
                if(!this.isMail){
                    this.$router.push('/bindMail')
                }
            }else if(obj == 2){
                if(!this.sec_question){
                    this.$router.push('/security')
                }
            }
        }
    },
    beforeDestroy(){

    }
}
</script>
<style scoped>
    .head{
        position: fixed;
        top: 0;
        width: 100%;
        height: 1.6rem;
        padding: 0 .44rem;
        color: #000;
        line-height: 1.6rem;
        background: #fff;
        box-sizing: border-box;
        text-align: center;
    }
    .head .back{
        position: absolute;
        left: .4rem;
        top: 50%;
        width: .5rem;
        margin-top: -.4rem;
    }
    .head .title{
        font-size: .56rem;
    }
    .head .text{
        font-size: .48rem;
    }
    .cotainer{
        position: absolute;
        top: 1.6rem;
        bottom: 0;
        width: 100%;
        background: #f9f9f9;
        overflow-y: scroll;
    }
    .cotainer .ul-box .li{
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-top: .3rem;
        padding: .6rem .45rem;
        color: #000;
        font-size: .42rem;
        background: #fff;
    }
    .cotainer .ul-box .li .arrow{
        width: .24rem;
    }
    .cotainer .ul-box .li .status{
        color: #588bf8;
    }
    .cotainer .ul-box .li:last-child{
        border-bottom: none;
    }
    .cotainer .ul-box .li .mail{
        color: #27895b;
        font-size: .42rem;
    }
    .cotainer .ul-box .li .mail.no-mail{
        flex: 1;
        padding-right: .2rem;
        color: #aaa;
        text-align: right;
    }
</style>



// WEBPACK FOOTER //
// src/pages/securityCenter.vue